module.exports = __webpack_public_path__ + "img/lg_ring_0_0_0_1.83dbd93c.png";